import React from "react";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";

export const NoPage404 = () => {
    return (
        <>
        <Header />
        <div>
            <h1>Nema strane koju str tražili ...</h1>
        </div>
        <Footer />
        </>
    );
}